import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from "firebase/storage"
import { auth, storage } from "../components/firebase/FirebaseConfig"

const API_URL = process.env.REACT_APP_API_URL || "https://impulsando-suenos-functions.netlify.app/.netlify/functions/api"
    // const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8888/.netlify/functions/api"

export const request = async (body, authenticated = true) => {
    const headers = { "Content-Type": "application/json" }
    if (authenticated && auth.currentUser) {
        headers.Authorization = `Bearer ${await auth.currentUser.getIdToken()}`
    }

    const response = await fetch(`${API_URL}/api`, {
        method: "POST",
        headers,
        body: JSON.stringify(body)
    })
    const result = await response.json()
    if (!response.ok) throw new Error(result.error || "No se pudo completar la operación")
    return result
}

const revive = value => {
    if (Array.isArray(value)) return value.map(revive)
    if (value && value.__timestamp) {
        return {
            seconds: value.seconds,
            nanoseconds: value.nanoseconds,
            toDate: () => new Date(value.seconds * 1000 + value.nanoseconds / 1000000)
        }
    }
    if (value && typeof value === "object") {
        return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, revive(item)]))
    }
    return value
}

const documentSnapshot = snapshot => ({
    id: snapshot.id,
    exists: () => snapshot.exists,
    data: () => revive(snapshot.data)
})

export const db = {}
export const collection = (_, path) => ({ path })
export const doc = (_, ...segments) => ({ path: segments.join("/") })
export const where = (field, operator, value) => ({ field, operator, value })
export const orderBy = (field, direction = "asc") => ({ field, direction })
export const limit = value => ({ max: value })
export const query = (reference, ...constraints) => ({
    path: reference.path,
    filters: constraints.filter(item => item.field && item.operator),
    ordering: constraints.find(item => item.direction),
    max: constraints.find(item => item.max)?.max
})

export const getDoc = async reference => documentSnapshot(await request({ action: "getDoc", path: reference.path }))

export const getDocs = async reference => {
    const result = await request({
        action: "getDocs",
        path: reference.path,
        filters: reference.filters || [],
        ordering: reference.ordering,
        max: reference.max
    })
    return { docs: result.docs.map(documentSnapshot), size: result.docs.length }
}

export const setDoc = (reference, data, options) => request({
    action: "setDoc", path: reference.path, data, merge: options?.merge
})

export const updateDoc = (reference, data) => request({ action: "updateDoc", path: reference.path, data })
export const deleteDoc = reference => request({ action: "deleteDoc", path: reference.path })
export const serverTimestamp = () => new Date()
export const Timestamp = { fromDate: date => date }

export const currentUser = () => request({ action: "currentUser" })
export const createUser = (email, password, profile) => request({ action: "createUser", email, password, profile })
export const registerAffiliate = affiliate => request({ action: "registerAffiliate", affiliate }, false)
export const registerCanje = canje => request({ action: "registerCanje", canje })
export const getRedSummary = () => request({ action: "redSummary" })
export const geocode = address => request({ action: "geocode", address })

export const uploadFile = (path, file) => new Promise((resolve, reject) => {
    const uploadTask = uploadBytesResumable(ref(storage, path), file, {
        contentType: file.type || "application/octet-stream"
    })

    uploadTask.on(
        "state_changed",
        undefined,
        reject,
        async () => {
            try {
                resolve({ url: await getDownloadURL(uploadTask.snapshot.ref) })
            } catch (error) {
                reject(error)
            }
        }
    )
})

export const deleteFile = path => deleteObject(ref(storage, path))
export const lookupPostalCode = cp => request({ action: "postalCode", cp })
export const sendWelcomeEmail = data => request({ action: "sendWelcomeEmail", ...data })
